import superagent from 'superagent';

const URL = 'https://tvactivator.do.cloudwalker.tv/tvactivatorService/v1';

export const getPO = (vendor, callback) => {
    superagent
        .post(URL + '/getPO')
        .set('Content-Type', 'application/json')
        .send({ vendor: [vendor] })
        .end((err, response) => {
            if (err) {
                callback(null);
                console.log('getPO request failed', err);
            } else if (response.status === 200) {
                callback(response.body);
            } else {
                callback(null);
            }
        });
};
